import * as React from 'react';
import { Icon } from '../icon';

interface Props {
  type: 'info' | 'warning' | 'error' | 'success';
  title?: string;
  onClick?: (...args: unknown[]) => void;
  size?: 'small' | 'medium';
}

const StyledTitle = ({ title, type, onClick, size }: Props) => {
  const [isHovered, setHovered] = React.useState(false);

  const setHoveredState = () => {
    setHovered(true);
  };

  const unsetHoveredState = () => {
    setHovered(false);
  };

  return (
    <div
      className="message-title-hoverable"
      onClick={onClick}
      onMouseOver={setHoveredState}
      onMouseOut={unsetHoveredState}
    >
      <span className="hoverable-icon">
        <Icon type={type} isHovered={isHovered} size={size} />
      </span>
      <span className="hoverable-text">{title}</span>
    </div>
  );
};

export default StyledTitle;
